// Main
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Tab from 'bootstrap/js/dist/tab';
import Modal from 'bootstrap/js/dist/modal';
import "./carousel.js";
import "./gallery.js";
import "./alert-banner.js";

const body = document.querySelector('body');

// When the DOM is loaded, remove "preload"

document.addEventListener('DOMContentLoaded', function() {
  body.classList.remove('preload');
});


// Close Mobile Menu if it's open and the browser changes to wider than the main nav breakpoint

const mobileMenuEl = document.getElementById('mobile-menu');
const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');

if (mobileMenuEl) {
  const mobileMenu = new Offcanvas(mobileMenuEl);
  const navBp = '1200px';
  let menuOpen = false;

  mobileMenuEl.addEventListener('show.bs.offcanvas', function (event) {
    menuOpen = true;
  })

  mobileMenuEl.addEventListener('hide.bs.offcanvas', function (event) {
    menuOpen = false;
  })

  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', () => mobileMenu.show());
  }

  const mediaQuery = window.matchMedia(`(min-width: ${navBp})`);

  function handleMobileChange(e) {
    if (e.matches && menuOpen) {
      mobileMenu.hide();
    }
  }

  // Register event listener
  mediaQuery.addEventListener('change', handleMobileChange);

  // Initial check
  handleMobileChange(mediaQuery);
}


// Functions to shift the nav and mobile menu toggle
//
// Opening a modal or offcanvas will hide the scrollbar (if there is one).
// Bootstrap adds padding on the right of the body element to prevent a layout shift.
// We pull the padding applied to the body to apply a shift to the nav elements since they
// are absolutely positioned and not affected by body padding.

const mainNav = document.getElementById('main-nav');

if (mobileMenuToggle || mainNav) {
  const toggleOffset = getComputedStyle(mobileMenuToggle).right;

  function shiftNav() {
    window.requestAnimationFrame(function () {
      let bodyPadd = document.body.style.paddingRight;

      if (bodyPadd.length > 0) {
        if (mobileMenuToggle) {
          mobileMenuToggle.style.right = parseInt(toggleOffset, 10) + parseInt(bodyPadd, 10) + 'px';
        }
        if (mainNav) mainNav.style.paddingRight = bodyPadd;
      }
    })
  }

  function unshiftNav() {
    if (mobileMenuToggle) mobileMenuToggle.style.right = toggleOffset;
    if (mainNav) mainNav.style.paddingRight = '';
  }

  document.addEventListener('show.bs.offcanvas', shiftNav);
  document.addEventListener('show.bs.modal', shiftNav);

  document.addEventListener('hidden.bs.offcanvas', unshiftNav);
  document.addEventListener('hidden.bs.modal', unshiftNav);
}
